/**
 * Shared react-modal entrance/exit animation wiring for the booking modal and its
 * stacked nested overlays.
 *
 * react-modal needs `closeTimeoutMS` (to keep the modal mounted while the exit
 * animation plays) and the object form of className/overlayClassName so the
 * base / after-open / before-close classes are applied cleanly (the string form
 * would append the suffix to the last token of a multi-class name).
 *
 * Pairs with the `.hopn-modal-container` / `.hopn-modal-overlay` `--before-close`
 * CSS: slide up on open, slide down on close (mobile); backdrop fades both ways.
 */
export const MODAL_CLOSE_MS = 520;

export function modalContainerClass(extra = '') {
  return {
    base: `hopn-modal-container${extra ? ` ${extra}` : ''}`,
    afterOpen: 'hopn-modal-container--after-open',
    beforeClose: 'hopn-modal-container--before-close',
  };
}

export function modalOverlayClass(extra = '') {
  return {
    base: `hopn-modal-overlay${extra ? ` ${extra}` : ''}`,
    afterOpen: 'hopn-modal-overlay--after-open',
    beforeClose: 'hopn-modal-overlay--before-close',
  };
}
